import { useEffect, useRef, useState } from 'react'
import { api } from '../services/api'
import umgSymbolUrl from '../assets/umg-symbol.svg?no-inline'
import noticesUrl from '../legal/third-party-notices.txt?no-inline'
import './LegalFooter.css'

const RELEASE_VERSION = /^\d+\.\d+\.\d+$/

export function LegalFooter() {
  const dialog = useRef<HTMLDialogElement>(null)
  const [version, setVersion] = useState<string | null>(null)

  // Builds without a release version (for example "dev") show no version.
  useEffect(() => {
    let cancelled = false
    api.get<{ version?: string }>('/health')
      .then((health) => {
        if (!cancelled && health.version && RELEASE_VERSION.test(health.version)) setVersion(health.version)
      })
      .catch(() => {})
    return () => { cancelled = true }
  }, [])

  return (
    <footer className="legal-footer" aria-label="Product information">
      <span className="legal-org">
        <img src={umgSymbolUrl} width={16} height={16} alt="" aria-hidden="true" />
        © {new Date().getFullYear()} UMG Systems LLC
      </span>
      {version && <><span aria-hidden="true">·</span><span>Sentyr Cloud v{version}</span></>}
      <span aria-hidden="true">·</span>
      <button type="button" className="legal-trigger" onClick={() => dialog.current?.showModal()}>Privacy &amp; Legal</button>
      <dialog ref={dialog} className="legal-dialog" aria-labelledby="legal-title">
        <h2 id="legal-title">Privacy &amp; Legal</h2>
        <p>Sentyr Cloud is a product of UMG Systems LLC.</p>
        <section>
          <h3>Privacy</h3>
          <p>This page shows no installation data before you sign in.</p>
          <p>Cloud stores account email addresses, hashed passwords, organization and site records, Core records and the access events your Cores send.</p>
          <p>Cloud keeps an audit record of sign-ins and account actions, including the account email.</p>
          <p>Requests to a Core pass through Cloud. Commands for an offline Core are stored until they are delivered or expire.</p>
          <p>Your browser stores only your theme choice. Sign-in tokens stay in page memory. Cloud sets no cookies.</p>
          <p>Access events are deleted after the number of days the operator sets. Without that setting they are kept. Audit records are not deleted automatically.</p>
          <p>Organization administrators can delete user accounts.</p>
          <p>When an organization requires email sign-in codes, Cloud emails a code to the account and stores only a keyed hash of it. A code expires after 5 minutes.</p>
        </section>
        <section>
          <h3>Connections</h3>
          <p>Email relay: off until the operator sets an SMTP host. When on, Cloud sends invitations, password resets and sign-in codes to account addresses.</p>
          <p>UMG licensing: off until the operator sets a licensing server address. When on, Cloud sends its version, host name, host fingerprint, primary network hardware address and status.</p>
          <p>Cores connect to Cloud. Cloud makes no other outbound connections.</p>
        </section>
        <section>
          <h3>Third-party software</h3>
          <p><a href={noticesUrl} target="_blank" rel="noopener noreferrer">Software licence notices</a></p>
          <p>These notices cover the direct dependencies of the web interface and the server.</p>
        </section>
        <button type="button" className="legal-close" onClick={() => dialog.current?.close()}>Close</button>
      </dialog>
    </footer>
  )
}
